import axios from 'axios';

const headers = {
  'Content-Type': 'application/json',
};

export interface Props {
  company: string;
  companyNumber: string;
  companyAddress?: string;
  managerName: string;
  managerNumber: string;
  managerEmail: string;
  brandName: string;
  salesChannel: string;
  checkedList: string[];
  file1: string;
  file2: string;
}

export const sendMessage = async (
  {
    company,
    companyNumber,
    companyAddress,
    managerName,
    managerNumber,
    managerEmail,
    brandName,
    salesChannel,
    checkedList,
    file1,
    file2,
  }: Props,
  url: string | undefined
) => {
  try {
    const { data }: any = await axios({
      method: 'post',
      url,
      headers,
      data: {
        blocks: [
          {
            type: 'header',
            text: {
              type: 'plain_text',
              text: company,
            },
          },
          {
            type: 'section',
            fields: [
              {
                type: 'mrkdwn',
                text: '*사업자명:*\n' + company,
              },
              {
                type: 'mrkdwn',
                text: '*사업자등록번호:*\n' + companyNumber,
              },
              {
                type: 'mrkdwn',
                text: '*홈페이지:*\n' + companyAddress,
              },
            ],
          },
          {
            type: 'section',
            fields: [
              {
                type: 'mrkdwn',
                text: '*영업담당자 이름:*\n' + managerName,
              },
              {
                type: 'mrkdwn',
                text: '*영업담당자 번호:*\n' + managerNumber,
              },
              {
                type: 'mrkdwn',
                text: '*영업담당자 이메일:*\n' + managerEmail,
              },
            ],
          },
          {
            type: 'section',
            fields: [
              {
                type: 'mrkdwn',
                text: '*판매브랜드:*\n' + brandName,
              },
              {
                type: 'mrkdwn',
                text: '*기존 판매채널:*\n' + salesChannel,
              },
              {
                type: 'mrkdwn',
                text: '*상품 카테고리:*\n' + checkedList,
              },
            ],
          },
          {
            type: 'section',
            text: {
              type: 'mrkdwn',
              text: '사업자등록증',
            },
            accessory: {
              type: 'button',
              text: {
                type: 'plain_text',
                text: 'link',
              },
              value: '사업자등록증',
              url: file1,
              action_id: 'button-action',
            },
          },
          {
            type: 'section',
            text: {
              type: 'mrkdwn',
              text: '통신판매업 신고증',
            },
            accessory: {
              type: 'button',
              text: {
                type: 'plain_text',
                text: 'link',
              },
              value: '통신판매업 신고증',
              url: file2,
              action_id: 'button-action',
            },
          },
        ],
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};
